module.exports = __webpack_public_path__ + "static/media/course-default-image.5266a847.webp";